import { onLogin } from '@/apollo'
import axios from 'axios'

export default {
  props: {
    csrfToken: {
      type: String,
      default: ''
    },
    targetPath: {
      type: String,
      default: ''
    },
    useTargetPath: {
      type: String,
      default: ''
    }
  },
  methods: {
    doContaoAndApolloLogin (username, password, redirectToAfterLogin = '/') {
      const _this = this
      return new Promise(function (resolve, reject) {
        _this.$store.dispatch('login', { username: username.replace(/ /g, ''), password: password }).then(jwt => {
          // login for apollo client
          onLogin(_this.$apolloProvider.defaultClient, jwt)

          document.querySelectorAll('.disableOnLogout').forEach((elm) => {
            elm.removeAttribute('disabled')
          })

          this.doContaoLogin(jwt).then(response => {
            resolve()
          }).catch(e => {
            reject(e)
          })
        }, error => {
          if (error.response && error.response.data) {
            _this.$store.commit('addError', error.response.data)
            this.errorMsg = error.response.data.message
          } else if (error.message) {
            this.errorMsg = error.message
            _this.$store.commit('addError', { message: error.message })
          } else {
            _this.$store.commit('addError', 'technical error!')
            this.errorMsg = 'Uff! Ein technischer Fehler ist aufgetreten. Sorry dafür! Bitte versuche es später noch einmal.'
          }
          reject(new Error('login failed'))
        })
      })
    },
    doContaoLogin (jwt) {
      const _this = this
      return new Promise(function (resolve, reject) {
        // build request
        const headers = {
          'X-Requested-With': 'XMLHttpRequest'
        }
        const loginFormData = new FormData()
        console.log('_this.csrfToken', _this.csrfToken)
        console.log('_this.accessToken', _this.accessToken)
        loginFormData.append('FORM_SUBMIT', 'tl_login_1')
        loginFormData.append('REQUEST_TOKEN', _this.csrfToken)
        loginFormData.append('_target_path', 'Lw==')
        loginFormData.append('_always_use_target_path', '0')
        loginFormData.append('username', 'jwt')
        loginFormData.append('password', _this.accessToken)

        axios.post('/login', loginFormData, {
          headers
        }).then(response => {
          console.log('logged in', response)
          resolve()
        }).catch(e => {
          console.log('login failed', e)
          _this.$store.commit('addError', e.message)
          reject(e)
        })
      })
    }
  }
}
